<div class="em-c-field" [ngClass]="{ 'em-has-error': error }">
  <label for="" class="em-c-field__label">Plant</label>
  <div class="em-c-field__body">
    <div class="ng-autocomplete">
      <ng-autocomplete
        #auto
        [data]="data"
        [searchKeyword]="keyword"
        (selected)="selectEvent($event)"
        (inputChanged)="onChangeSearch($event)"
        (inputFocused)="onFocused($event)"
        [itemTemplate]="itemTemplate"
        [placeholder]="'Plant Code or Plant Name'"
        [isLoading]="isLoading"
        [debounceTime]="700"
      >
      </ng-autocomplete>
    </div>

    <ng-template #itemTemplate let-item>
      <a [innerHTML]="item.fullName"></a>
    </ng-template>

    <ng-template #notFoundTemplate let-notFound>
      <div [innerHTML]="notFound"></div>
    </ng-template>
  </div>
  <div class="em-c-field__note" *ngIf="!error">
    Which plant this supplier belong to.
  </div>
  <div class="em-c-field__note" *ngIf="error">{{ error }}</div>
</div>
